import TR from 'utils/TR';
import HBox from 'components/common/HBox';
import T from 'utils/T';
import ex from 'utils/ex';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import FocusableButton from 'components/common/FocusableButton';
import ResetDialog from 'components/dialogs/ResetDialog';
import DialogButton from 'components/common/DialogButton';
import React from 'react';

export default function DoctorInfo(props) {
  const doctor_info = Recoil.useRecoilValue(AppStore.assets.doctor_info);

  const [disabled, setDisabled] = React.useState(true);
  const onToggle = React.useCallback((value) => () => {
    setDisabled(() => value);
  }, []);

  React.useEffect(() => {
    return () => {
      setDisabled(() => false);
    };
  }, []);

  return (
    <div {...ex('DoctorInfo', props)}>
      <HBox>
        <div {...ex('DoctorOffice')}>
          {doctor_info?.hospital}
        </div>
        <div>|</div>
        <div {...ex('DoctorSpecialty')}>
          {doctor_info?.department}
        </div>
      </HBox>
      <div {...ex('DoctorName')}>
        {T('Dr. {0}', (doctor_info?.name || '').split('').join(' '))}
      </div>
      <DialogButton
        {...ex('RetrieveButton')}
        {...{
          disabled,
          category: 'App',
          label: (
            <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width={24} height={24} rx={12} fill="#2E5DCC" fillOpacity="0.1" />
              <path d="M8.5 14C8.0875 14 7.7345 13.853 7.441 13.559C7.147 13.2655 7 12.9125 7 12.5C7 12.0875 7.147 11.7342 7.441 11.4402C7.7345 11.1467 8.0875 11 8.5 11C8.9125 11 9.2655 11.1467 9.559 11.4402C9.853 11.7342 10 12.0875 10 12.5C10 12.9125 9.853 13.2655 9.559 13.559C9.2655 13.853 8.9125 14 8.5 14ZM8.5 17C7.25 17 6.1875 16.5625 5.3125 15.6875C4.4375 14.8125 4 13.75 4 12.5C4 11.25 4.4375 10.1875 5.3125 9.3125C6.1875 8.4375 7.25 8 8.5 8C9.3375 8 10.097 8.20625 10.7785 8.61875C11.4595 9.03125 12 9.575 12.4 10.25H18L20.25 12.5L16.875 15.875L15.375 14.75L13.875 15.875L12.2812 14.75H12.4C12 15.425 11.4595 15.9687 10.7785 16.3812C10.097 16.7937 9.3375 17 8.5 17ZM8.5 15.5C9.2 15.5 9.81575 15.2875 10.3472 14.8625C10.8783 14.4375 11.2312 13.9 11.4062 13.25H12.75L13.8375 14.0187L15.375 12.875L16.7062 13.9062L18.1125 12.5L17.3625 11.75H11.4062C11.2312 11.1 10.8783 10.5625 10.3472 10.1375C9.81575 9.7125 9.2 9.5 8.5 9.5C7.675 9.5 6.96875 9.79375 6.38125 10.3813C5.79375 10.9688 5.5 11.675 5.5 12.5C5.5 13.325 5.79375 14.0312 6.38125 14.6187C6.96875 15.2062 7.675 15.5 8.5 15.5Z" fill="#2E5DCC" />
            </svg>
          ),
          onMouseOver: onToggle(false),
          onMouseEnter: onToggle(false),
          onMouseLeave: onToggle(true),
          onMouseOut: onToggle(true),
        }}
      >
        <ResetDialog />
      </DialogButton>
    </div>
  );
}
